import ContactUsComponent from "@components/ContactUs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import SeoHead from "@components/SeoHead";
import ZohoChatWidget from "@components/ZohoChatWidget";
import { useGenzoTracking } from "@context/tracking/genzo";
import withSiteConfig, { getSiteConfig } from "@context/withSiteConfig";
import withTranslations, { getTranslations } from "@context/withTranslations";
import { getContactPageView } from "@helpers/genzo/genzoPageViewBuilders";
import { GetServerSideProps, NextPage } from "next";
import { useEffect } from "react";
import styles from "./index.module.scss";

const ContactUs: NextPage = () => {
  const { trackPageView } = useGenzoTracking();

  useEffect(() => {
    trackPageView(getContactPageView());
  }, []);
  return (
    <>
      <SeoHead page="contact-us" />
      <ZohoChatWidget />
      <Header />
      <div className={styles.container}>
        <ContactUsComponent />
      </div>
      <Footer />
    </>
  );
};
export const getServerSideProps: GetServerSideProps = async (context) => {
  const env = process.env.APP_ENV;
  const siteConfig = getSiteConfig(context, env);
  const translations = await getTranslations(siteConfig);

  return { props: { siteConfig, translations } };
};

export default withTranslations(withSiteConfig(ContactUs));
